import PullToRefresh from './src/PullToRefresh';

PullToRefresh.install=function(Vue){
	Vue.component(PullToRefresh.name, PullToRefresh);
}

export default PullToRefresh



// WEBPACK FOOTER //
// ./src/components/PullToRefresh/index.js